module.exports = __webpack_public_path__ + "static/media/Restaurant Menu Name.8d983b5b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/cont/Restaurant Menu Name.png
// module id = 1192
// module chunks = 0